import HomePage from '@/pages/home/HomePage.vue';

import type { RouteRecordRaw } from 'vue-router';

export const mfRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
];
